export default {
    NOT_RESPOND  : 0,
    FAKE_USER    : 1,
    TEST_ACCOUNT : 2
}